import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiPost } from '../query';

export function useForgotPassword() {
  const queryClient = useQueryClient();
  const apipost = useApiPost({ isLogoutApi: true });

  return useMutation({
    mutationFn: async (body: { EmailAddress: string; UserName: string }) => {
      const { EmailAddress, UserName } = body;
      const updateData = {
        emailAddress: EmailAddress,
        userName: UserName,
      };
      const data = await apipost(
        '/account-management/v1/users/forgot-password',
        updateData
      );
      return data;
    },
    onError: () => {
      return;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['/account-management/v1/users/forgot-password'],
      });
    },
  });
}
